/**
 * @generated SignedSource<<9b7c808945ab5ed4405410c2b786ee4c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contentNewsletterWidgetContent$data = {
  readonly relatedNewsletters?: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"helpersMassageToNewsletterItemNewsletter">;
  } | null | undefined> | null | undefined;
  readonly sectionsV2: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly relatedNewsletters?: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"helpersMassageToNewsletterItemNewsletter">;
      } | null | undefined> | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly topics: ReadonlyArray<{
    readonly relatedNewsletters: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"helpersMassageToNewsletterItemNewsletter">;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "contentNewsletterWidgetContent";
};
export type contentNewsletterWidgetContent$key = {
  readonly " $data"?: contentNewsletterWidgetContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"contentNewsletterWidgetContent">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "text",
    "storageKey": null
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Newsletter",
    "kind": "LinkedField",
    "name": "relatedNewsletters",
    "plural": true,
    "selections": [
      {
        "kind": "InlineDataFragmentSpread",
        "name": "helpersMassageToNewsletterItemNewsletter",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "entityId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "alternativeName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FormattedValue",
            "kind": "LinkedField",
            "name": "description",
            "plural": false,
            "selections": (v0/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FormattedValue",
            "kind": "LinkedField",
            "name": "summary",
            "plural": false,
            "selections": (v0/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FormattedValue",
            "kind": "LinkedField",
            "name": "homepageDescription",
            "plural": false,
            "selections": (v0/*: any*/),
            "storageKey": null
          }
        ],
        "args": null,
        "argumentDefinitions": ([]/*: any*/)
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "contentNewsletterWidgetContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Topic",
      "kind": "LinkedField",
      "name": "topics",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSegmentV2",
      "kind": "LinkedField",
      "name": "sectionsV2",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "value",
          "plural": true,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "Section",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "Article",
      "abstractKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};
})();

(node as any).hash = "bb04b0b20cb42b5314f5672692611c24";

export default node;
